import VueRouter from "vue-router";

Vue.use(VueRouter);

let routes = [
    {
        path: '*',
        redirect: '/chart',
    },
    {
        path: '/chart',
        components: {
            default: require('./spa/Chart.vue').default,
            sidebar: require('./spa/ChartSide.vue').default,
        },
    },
    {
        path: '/table',
        components: {
            default: require('./spa/Table.vue').default,
            sidebar: require('./spa/TableSide').default,
        },
    },
    {
        path: '/ranking',
        components: {
            default: require('./spa/Ranking.vue').default,
            sidebar: require('./spa/MotionSide.vue').default,
        },
    },
    {
        path: '/series',
        component: require('./spa/Series.vue').default,
    },
    {
        path: '/export',
        component: require('./spa/Export.vue').default,
    },
];

export default new VueRouter({
    routes
});
